import { Vault } from "@randajan/vault-kit";
import { collectGameStats } from "../../../arc/game/collectStats";
import { globalStatsBeam } from "../beams/globalStatsBeam";
import { meBeam } from "../beams/meBeam";
import { createQueue } from "@randajan/queue";


export const userStatsVault = new Vault({
    remote:{
        pull:async _=>{
            const [ gStats, me ] = await Promise.all([
                globalStatsBeam.get(),
                meBeam.get()
            ]);

            if (!gStats || !me) { return gStats; }
            return collectGameStats(gStats.rounds?.list, { me });
        }
    }
});

const resetUserStatsVault = createQueue(_=>userStatsVault.reset(), {
    softMs:200,
    hardMs:1000,
});

globalStatsBeam.on(resetUserStatsVault);
meBeam.on(resetUserStatsVault);